// @flow
import { conditionMatcherFor, type Where } from './object-query-matcher';
import type { AbstractCatalog } from './abstract-catalog';

export type AutomaticShipmentsSettingEntry = $ReadOnly<{|
  optionIsAvailable: boolean,
  defaultValue: boolean,
  where?: Where,
|}>;

export type AutomaticShipmentsSetting = AutomaticShipmentsSettingEntry[];

export type Params = $ReadOnly<{|
  automaticShipments: AutomaticShipmentsSetting,
  catalog: AbstractCatalog,
|}>;

// the default AutomaticShipmentsSettingEntry is added here
// because it cannot be filtered out, it provides return type saftey
const automaticShipmentsForCatalog = ({
  automaticShipments,
  catalog,
}: Params): AutomaticShipmentsSettingEntry =>
  [
    ...automaticShipments,
    { optionIsAvailable: false, defaultValue: false },
  ].filter(conditionMatcherFor(catalog, 'catalog'))[0];

/**
 * The optionIsAvailable property on the automatic shipment setting
 * enables the toggling of the automatic shipments
 * via the new order dialog
 */
export const automaticShipmentsCanBeToggledByUser = (params: Params): boolean =>
  automaticShipmentsForCatalog(params).optionIsAvailable;

/**
 * The defaultValue property on the automaticShipment setting determines
 *  if automatic shipments should be enabled or disabled by default
 */
export const automaticShipmentsAreEnabledByDefault = (
  params: Params,
): boolean => automaticShipmentsForCatalog(params).defaultValue;
